import { bl_fi_slsodr_to_slsinv_consol_run_hdr_slsinv_link_RowClass } from "../../dbschema/bl_fi_slsodr_to_slsinv_consol_run_hdr_slsinv_link.model";
import { BaseContainerModel } from "../base-container.model";

export class SOConsolidationLinkModel extends BaseContainerModel {
  bl_fi_slsodr_to_slsinv_consol_run_hdr_slsinv_link: bl_fi_slsodr_to_slsinv_consol_run_hdr_slsinv_link_RowClass =
    new bl_fi_slsodr_to_slsinv_consol_run_hdr_slsinv_link_RowClass();
}
